const statuses = {
  DISABLED: 0,
  ENABLED: 1,
};

export const types: {[socialSite: string]: string} = {
  Twitter: 'Twitter',
  Facebook: 'Facebook',
  Instagram: 'Instagram',
  YouTube: 'YouTube',
  TikTok: 'TikTok',
};

// eslint-disable-next-line import/prefer-default-export
export function isDisabled(status: number): boolean {
  return (statuses.DISABLED === status);
}
